export default "__VITE_ASSET__BhV4Qp$d__"